/*
 * Built-in icon set and the icon spec resolver.
 *
 * An icon spec can be:
 *   'star'                         a built-in name (see ICONS)
 *   '<svg …>…</svg>'               an inline SVG string (rendered as-is)
 *   'https://…/x.svg' | '/x.svg'   a URL; rendered through a CSS mask so it
 *   | 'data:image/svg+xml…'        takes the current text colour per state
 *   { className: 'fa-solid fa-star' }  an <i> with those classes, for hosts
 *                                  that load an icon font
 *   null / undefined               no icon
 * Every built-in icon is a 24×24 viewBox drawn with currentColor so it picks
 * up the component's state colour.
 */

const STROKE = 'fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
const wrap = (inner) => `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">${inner}</svg>`;

export const ICONS = {
	'star': wrap('<path fill="currentColor" d="M12 2.6l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.5l-5.9 3.1 1.2-6.5L2.5 9.5l6.6-.9z"/>'),
	'star-outline': wrap(`<path ${STROKE} d="M12 2.6l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.5l-5.9 3.1 1.2-6.5L2.5 9.5l6.6-.9z"/>`),
	'heart': wrap('<path fill="currentColor" d="M12 21s-7.6-4.7-9.6-9.3C1.1 8.3 3.3 4.8 6.8 4.8c2 0 3.6 1.2 5.2 3.1 1.6-1.9 3.2-3.1 5.2-3.1 3.5 0 5.7 3.5 4.4 6.9C19.6 16.3 12 21 12 21z"/>'),
	'heart-outline': wrap(`<path ${STROKE} d="M12 21s-7.6-4.7-9.6-9.3C1.1 8.3 3.3 4.8 6.8 4.8c2 0 3.6 1.2 5.2 3.1 1.6-1.9 3.2-3.1 5.2-3.1 3.5 0 5.7 3.5 4.4 6.9C19.6 16.3 12 21 12 21z"/>`),
	'circle': wrap(`<circle ${STROKE} cx="12" cy="12" r="8"/>`),
	'circle-filled': wrap('<circle fill="currentColor" cx="12" cy="12" r="8"/>'),
	'dot': wrap('<circle fill="currentColor" cx="12" cy="12" r="4"/>'),
	'check': wrap(`<path ${STROKE} d="M5 12.5l4.5 4.5L19 7"/>`),
	'minus': wrap(`<path ${STROKE} d="M5 12h14"/>`),
	'plus': wrap(`<path ${STROKE} d="M12 5v14M5 12h14"/>`),
	'xmark': wrap(`<path ${STROKE} d="M6 6l12 12M18 6L6 18"/>`),
	'exclamation': wrap(`<path ${STROKE} d="M12 5v9"/><circle fill="currentColor" cx="12" cy="18.5" r="1.3"/>`),
	'info': wrap(`<circle fill="currentColor" cx="12" cy="6.5" r="1.3"/><path ${STROKE} d="M12 10.5v8"/>`),
	'warning': wrap(`<path ${STROKE} d="M12 3.8L2.6 20h18.8z"/><path ${STROKE} d="M12 9.5v4.5"/><circle fill="currentColor" cx="12" cy="17" r="1.1"/>`),
	'trophy': wrap(`<path ${STROKE} d="M7 4h10v3.5a5 5 0 0 1-10 0V4zM7 5.5H4v1.5a3 3 0 0 0 3 3M17 5.5h3v1.5a3 3 0 0 1-3 3M12 12.5v3.5M8 20h8M9.5 16h5v4h-5z"/>`),
	'flag': wrap(`<path ${STROKE} d="M5.5 21V4h11l-1.6 4 1.6 4H5.5"/>`),
	'user': wrap(`<path ${STROKE} d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20.5c0-3.9 3.4-6.5 7.5-6.5s7.5 2.6 7.5 6.5"/>`),
	'users': wrap(`<path ${STROKE} d="M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c0-3.5 2.9-6 6.5-6s6.5 2.5 6.5 6M16 4.5a3.5 3.5 0 0 1 0 6.5M18 14.5c2.3.6 3.5 2.8 3.5 5.5"/>`),
	'upload': wrap(`<path ${STROKE} d="M12 16V4M6.5 9.5L12 4l5.5 5.5M4 20h16"/>`),
	'download': wrap(`<path ${STROKE} d="M12 4v12M6.5 10.5L12 16l5.5-5.5M4 20h16"/>`),
	'clock': wrap(`<circle ${STROKE} cx="12" cy="12" r="8.5"/><path ${STROKE} d="M12 7.5v5l3 2"/>`),
	'calendar': wrap(`<rect ${STROKE} x="3.5" y="5" width="17" height="15.5" rx="2"/><path ${STROKE} d="M3.5 10h17M8 3v4M16 3v4"/>`),
	'percent': wrap(`<path ${STROKE} d="M6 18L18 6"/><circle ${STROKE} cx="7.5" cy="7.5" r="2.2"/><circle ${STROKE} cx="16.5" cy="16.5" r="2.2"/>`),
	'pound': wrap(`<path ${STROKE} d="M15.5 6.5A3.5 3.5 0 0 0 9 8v7.5L7 19h10M7 12.5h6"/>`),
	'dollar': wrap(`<path ${STROKE} d="M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3S7.5 5.8 7.5 7.5c0 4.5 9 2 9 6.5 0 1.7-2 3-4.5 3s-4.5-1.3-4.5-3"/>`),
	'pencil': wrap(`<path ${STROKE} d="M4 20l4.5-1 10-10-3.5-3.5-10 10z M13.5 7l3.5 3.5"/>`),
	'search': wrap(`<circle ${STROKE} cx="10.5" cy="10.5" r="6"/><path ${STROKE} d="M15 15l5 5"/>`),
	'chevron-right': wrap(`<path ${STROKE} d="M9 5l7 7-7 7"/>`),
	'chevron-left': wrap(`<path ${STROKE} d="M15 5l-7 7 7 7"/>`),
	'chevron-down': wrap(`<path ${STROKE} d="M5 9l7 7 7-7"/>`),
	'file': wrap(`<path ${STROKE} d="M6 3h8l4 4v14H6z M14 3v4h4"/>`),
	'document': wrap(`<path ${STROKE} d="M6 3h8l4 4v14H6z M14 3v4h4M9 12h6M9 16h6"/>`),
	'bolt': wrap('<path fill="currentColor" d="M13 2L4 14h6l-1 8 9-12h-6z"/>'),
	'bell': wrap(`<path ${STROKE} d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20a2 2 0 0 0 4 0"/>`),
	'lock': wrap(`<rect ${STROKE} x="5" y="10.5" width="14" height="10" rx="2"/><path ${STROKE} d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>`),
	'send': wrap('<path fill="currentColor" d="M3 11.5L20.5 4l-4.2 16.5-5.3-6.2z"/><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="M11 14.3l9.5-10.3"/>'),
	'paperclip': wrap(`<path ${STROKE} d="M16.5 7.5l-7 7a2.1 2.1 0 0 0 3 3l7.5-7.5a4.2 4.2 0 0 0-6-6L6 12a6.4 6.4 0 0 0 9 9l5-5"/>`),
	'microphone': wrap(`<rect fill="currentColor" x="9" y="3" width="6" height="11" rx="3"/><path ${STROKE} d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3M9 21h6"/>`),
	'stop': wrap('<rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/>'),
	'image': wrap(`<rect ${STROKE} x="3.5" y="5" width="17" height="14" rx="2"/><circle fill="currentColor" cx="8.5" cy="9.5" r="1.5"/><path ${STROKE} d="M4 17l5-5 4 4 3-3 4.5 4.5"/>`),
	'trash': wrap(`<path ${STROKE} d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13M10 11v5M14 11v5"/>`),
	'bold': wrap('<path fill="currentColor" d="M7 4h6.2c2.6 0 4.3 1.5 4.3 3.8 0 1.4-.7 2.5-1.9 3.1 1.7.5 2.8 1.9 2.8 3.7 0 2.6-1.9 4.4-4.9 4.4H7V4zm2.8 2.4v4h2.9c1.3 0 2.1-.8 2.1-2s-.8-2-2.1-2H9.8zm0 6.3v4.9h3.4c1.5 0 2.4-.9 2.4-2.4s-.9-2.5-2.4-2.5H9.8z"/>'),
	'italic': wrap(`<path ${STROKE} d="M10 4h8M6 20h8M14 4l-4 16"/>`),
	'underline': wrap(`<path ${STROKE} d="M7 4v7a5 5 0 0 0 10 0V4M5 20h14"/>`),
	'strike': wrap(`<path ${STROKE} d="M4 12h16M8.5 7.5c0-1.9 1.7-3.2 3.7-3.2 1.7 0 3 .8 3.6 2M15.8 15.5c0 2.2-1.7 3.5-4 3.5-2 0-3.5-1-4.1-2.5"/>`),
	'palette': wrap(`<path ${STROKE} d="M12 3.5a8.5 8.5 0 1 0 0 17c1.3 0 2-.8 2-1.7 0-.6-.3-1-.3-1.6 0-.9.7-1.6 1.6-1.6h1.6a3.6 3.6 0 0 0 3.6-3.6C20.5 7 16.7 3.5 12 3.5z"/><circle fill="currentColor" cx="8" cy="12" r="1.3"/><circle fill="currentColor" cx="10" cy="8" r="1.3"/><circle fill="currentColor" cx="14.5" cy="7.5" r="1.3"/>`),
	'align-left': wrap(`<path ${STROKE} d="M4 6h16M4 10h10M4 14h16M4 18h10"/>`),
	'align-center': wrap(`<path ${STROKE} d="M4 6h16M7 10h10M4 14h16M7 18h10"/>`),
	'align-right': wrap(`<path ${STROKE} d="M4 6h16M10 10h10M4 14h16M10 18h10"/>`),
	'list-ul': wrap(`<path ${STROKE} d="M9 6h11M9 12h11M9 18h11"/><circle fill="currentColor" cx="5" cy="6" r="1.4"/><circle fill="currentColor" cx="5" cy="12" r="1.4"/><circle fill="currentColor" cx="5" cy="18" r="1.4"/>`),
	'list-ol': wrap(`<path ${STROKE} d="M10 6h10M10 12h10M10 18h10M4 5.5h1.5v3M4 8.5h3M4 11l2-1v4M4 14h3M4 16.5h2.5l-2.5 3h2.5"/>`),
	'indent': wrap(`<path ${STROKE} d="M4 6h16M10 10h10M10 14h10M4 18h16M4 10l3 2-3 2"/>`),
	'outdent': wrap(`<path ${STROKE} d="M4 6h16M10 10h10M10 14h10M4 18h16M7 10l-3 2 3 2"/>`),
	'link': wrap(`<path ${STROKE} d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>`),
	'eraser': wrap(`<path ${STROKE} d="M4.5 15.5l7-7 5.5 5.5-5 5H8.5zM9 20h11M9 10.5l5.5 5.5"/>`),
	'code': wrap(`<path ${STROKE} d="M8 7l-5 5 5 5M16 7l5 5-5 5M13.5 4l-3 16"/>`),
	'undo': wrap(`<path ${STROKE} d="M8 9H3.5V4.5M4 9.5A8 8 0 1 1 6.3 17"/>`),
	'redo': wrap(`<path ${STROKE} d="M16 9h4.5V4.5M20 9.5A8 8 0 1 0 17.7 17"/>`),
	'table': wrap(`<rect ${STROKE} x="3.5" y="4.5" width="17" height="15" rx="1.5"/><path ${STROKE} d="M3.5 10h17M3.5 15h17M9.5 4.5v15M15 4.5v15"/>`),
	'toc': wrap(`<path ${STROKE} d="M8 6h12M8 12h12M8 18h12M4 6h.5M4 12h.5M4 18h.5"/>`),
	'page-break': wrap(`<path ${STROKE} d="M6 3h8l4 4v4M6 3v8M4 14h3M9.5 14h5M16.5 14h3.5M6 17v4h12v-4"/>`),
	'print': wrap(`<path ${STROKE} d="M7 8V4h10v4M5 8h14a1.5 1.5 0 0 1 1.5 1.5v6H17v4H7v-4H3.5v-6A1.5 1.5 0 0 1 5 8zM7 15.5h10"/>`),
	'file-word': wrap(`<path ${STROKE} d="M6 3h8l4 4v14H6z M14 3v4h4M8.5 11l1.5 6 2-4.5 2 4.5 1.5-6"/>`),
	'comment': wrap(`<path ${STROKE} d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4H6.5A2.5 2.5 0 0 1 4 13.5z"/>`),
	'track-changes': wrap(`<path ${STROKE} d="M4 20h16M14.5 4.5l3 3L9 16H6v-3z"/>`),
	'review': wrap(`<path ${STROKE} d="M4 5h16v14H4zM14 5v14M16.5 9h1.5M16.5 12h1.5"/>`),
	'fit': wrap(`<path ${STROKE} d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5"/>`),
	'gear': wrap(`<circle ${STROKE} cx="12" cy="12" r="3"/><path ${STROKE} d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1"/>`),
};

const ICON_NAMES = Object.keys(ICONS);
export function iconNames() { return ICON_NAMES.slice(); }

/** Registers or overrides a built-in icon (SVG string). */
export function registerIcon(name, svg) { ICONS[name] = svg; }

function isUrl(s) { return /^(https?:)?\/\/|^\/|^\.{0,2}\/|^data:|\.svg(\?.*)?$/i.test(s); }

/**
 * Renders an icon spec to an element (or null). The element carries class
 * `dfc-icon` and sizes with font-size (1em), so components colour it via
 * `color` and size it via their own font-size.
 */
export function renderIcon(spec, extraClass) {
	if (spec === undefined || spec === null || spec === false || spec === '') return null;
	const span = document.createElement('span');
	span.className = 'dfc-icon' + (extraClass ? ' ' + extraClass : '');
	span.setAttribute('aria-hidden', 'true');
	if (typeof spec === 'object') {
		if (spec.className) { span.classList.add('dfc-icon-font'); const i = document.createElement('i'); i.className = spec.className; span.appendChild(i); return span; }
		if (spec.svg) spec = spec.svg; else if (spec.url) spec = spec.url; else if (spec.name) spec = spec.name; else return null;
	}
	spec = String(spec).trim();
	if (ICONS[spec]) { span.innerHTML = ICONS[spec]; return span; }
	if (/^<svg[\s>]/i.test(spec)) { span.innerHTML = spec; return span; }
	if (isUrl(spec)) {
		span.classList.add('dfc-icon-mask');
		span.style.setProperty('--dfc-icon-url', `url("${spec.replace(/"/g, '%22')}")`);
		return span;
	}
	// Unknown name: fall back to a neutral dot rather than nothing, so state is still visible.
	span.innerHTML = ICONS.dot;
	span.dataset.unknownIcon = spec;
	return span;
}

/** Same as renderIcon but returns an HTML string (for static renderers). */
export function iconHtml(spec, extraClass) {
	const el = renderIcon(spec, extraClass);
	return el ? el.outerHTML : '';
}
